var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliForm", {
    ref: "form",
    attrs: {
      title: _vm.relationship ? "Edit Relationship" : "Add Relationship",
      text: "Save",
      icon: "save",
      loadingProp: _vm.form.processing,
    },
    on: {
      reset: function ($event) {
        return _vm.$emit("reset")
      },
      submit: function ($event) {
        _vm.relationship ? _vm.editRelationship() : _vm.addRelationship()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _vm.can("Create students") &&
            _vm.$page.props.staffView &&
            !_vm.relationship
              ? _c("v-switch", {
                  staticClass: "px-2 mt-0",
                  attrs: { label: "Add New Client", dense: "" },
                  on: {
                    change: function ($event) {
                      ;[
                        (_vm.form.first_name = null),
                        (_vm.form.last_name = null),
                        (_vm.form.email = null),
                        (_vm.form.existingUser = null),
                      ]
                    },
                  },
                  model: {
                    value: _vm.addNewClient,
                    callback: function ($$v) {
                      _vm.addNewClient = $$v
                    },
                    expression: "addNewClient",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.can("Link existing clients") &&
            _vm.$page.props.staffView &&
            !_vm.relationship &&
            !_vm.addNewClient
              ? _c("SoliStudents", {
                  attrs: {
                    label: "Existing Clients",
                    autocomplete: "",
                    onDemand: "",
                    user: _vm.user,
                    filter: _vm.relationships.map((e) => e.name),
                  },
                  on: { input: _vm.selectExistingUser },
                  model: {
                    value: _vm.form.existingUser,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "existingUser", $$v)
                    },
                    expression: "form.existingUser",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.relationship && _vm.addNewClient
              ? _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          attrs: {
                            "prepend-inner-icon": "person",
                            label: "First Name",
                            outlined: "",
                            rules: _vm.rules.input,
                            dense: "",
                          },
                          model: {
                            value: _vm.form.first_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "first_name", $$v)
                            },
                            expression: "form.first_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Last Name",
                            outlined: "",
                            rules: _vm.rules.input,
                            dense: "",
                          },
                          model: {
                            value: _vm.form.last_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "last_name", $$v)
                            },
                            expression: "form.last_name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("v-select", {
              attrs: {
                items: _vm.relationshipOptions,
                "item-text": _vm.getRelation,
                label: "Relationship",
                "return-object": "",
                outlined: "",
                dense: "",
                rules: _vm.rules.select,
                "prepend-inner-icon": "handshake",
              },
              model: {
                value: _vm.form.relation,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "relation", $$v)
                },
                expression: "form.relation",
              },
            }),
            _vm._v(" "),
            !_vm.relationship && _vm.form.loginable
              ? _c("v-text-field", {
                  attrs: {
                    label: "Email",
                    outlined: "",
                    "prepend-inner-icon": "alternate_email",
                    "validate-on-blur": "",
                    rules: _vm.rules.email,
                    dense: "",
                  },
                  model: {
                    value: _vm.form.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "email", $$v)
                    },
                    expression: "form.email",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.relationship && _vm.addNewClient
              ? _c("v-switch", {
                  staticClass: "px-2 mt-0",
                  attrs: { label: "Give login", dense: "" },
                  model: {
                    value: _vm.form.loginable,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "loginable", $$v)
                    },
                    expression: "form.loginable",
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }